import { useEffect, useRef } from "react";
var Position = /** @class */ (function () {
    function Position() {
        this.XPosition = 0;
        this.YPosition = 0;
        this.screenX = 0;
        this.screenY = 0;
    }
    return Position;
}());
export function useUnityMessages(message, handlers) {
    var handlersRef = useRef(null);
    // clé -> dernier log émis pour ce hotspot, pour ne logger que les changements utiles
    var lastLoggedRef = useRef(new Map());
    // keep latest handlers in a ref so the effect below doesn't need to re-run
    useEffect(function () {
        handlersRef.current = handlers;
    }, [handlers]);
    useEffect(function () {
        var _a, _b, _c;
        if (!message)
            return;
        var h = handlersRef.current;
        if (!h)
            return;
        try {
            switch (message.functionName) {
                case "UnityLog":
                    // Unity envoie parfois la stack trace C# complète dans parameters[0] :
                    // on ne garde que la 1ère ligne pour éviter de noyer la console.
                    if ((_a = message.parameters) === null || _a === void 0 ? void 0 : _a.length) {
                        var firstLine = String(message.parameters[0]).split("\n")[0];
                        console.log("%c[UNITY LOG]", "color:#00b7ff; font-weight:bold;", firstLine);
                    }
                    break;
                case "updateUI":
                    if (message.parameters) {
                        var newScene = message.parameters[0] || "";
                        console.log("[useUnityMessages] SCENE -> \"".concat(newScene, "\" @").concat(Date.now()));
                        lastLoggedRef.current.clear();
                        if (newScene === "Intro")
                            h.setInitialUpdate(true);
                        h.setSceneState(newScene);
                        h.setIsScene(newScene !== "Intro");
                    }
                    break;
                case "showPopUp":
                    if (message.parameters)
                        h.setProductName(message.parameters[0]);
                    break;
                case "incrementProduct":
                    if (message.objName)
                        h.trackProduct(message.objName);
                    break;
                case "multiPopUp":
                    if (message.parameters)
                        h.setProductNameMulti(message.parameters[0]);
                    break;
                case "showLabelName":
                    if (message.objName)
                        h.setHoveredProductName(message.objName);
                    h.setShowLabelProduct(true);
                    break;
                case "hideLabelName":
                    h.setShowLabelProduct(false);
                    break;
                case "updateLabelNamePosition":
                    if (((_b = message.parameters) === null || _b === void 0 ? void 0 : _b.length) === 4) {
                        h.setLabelPosition({
                            XPosition: Number(message.parameters[0]),
                            YPosition: Number(message.parameters[1]),
                            screenX: Number(message.parameters[2]),
                            screenY: Number(message.parameters[3]),
                        });
                    }
                    break;
                case "updateHotspotPosition": {
                    // Unity diffuse ces positions en continu depuis n'importe quelle
                    // scène, y compris des messages encore "en vol" juste après un
                    // changement de scène. Les points ne sont affichés que sur Intro
                    // (voir Hotspots.tsx) : on ignore tout le reste pour ne jamais
                    // stocker une position calculée depuis la mauvaise caméra.
                    var accepted = h.sceneState === "Intro";
                    if (((_c = message.parameters) === null || _c === void 0 ? void 0 : _c.length) === 4) {
                        var key = message.objName || "";
                        var valueKey = message.parameters.join(",");
                        var last = lastLoggedRef.current.get(key);
                        // On ne logue que : 1er message pour ce hotspot depuis la transition,
                        // ou changement de statut accepté/ignoré, ou valeur figée depuis >1s
                        // (utile pour voir si Unity reste bloqué sur une position obsolète).
                        var shouldLog = !last || last.accepted !== accepted ||
                            (last.valueKey === valueKey ? Date.now() - last.ts > 1000 : true);
                        if (shouldLog) {
                            console.log("[HS] ".concat(key, " @").concat(Date.now(), " scene=\"").concat(h.sceneState, "\" ").concat(valueKey, " -> ").concat(accepted ? "OK" : "IGNORÉ"));
                        }
                        if (!last || last.valueKey !== valueKey || shouldLog) {
                            lastLoggedRef.current.set(key, { valueKey: valueKey, accepted: accepted, ts: Date.now() });
                        }
                        if (!accepted)
                            break;
                        h.updateHotspot(message.objName ? message.objName : "", Number(message.parameters[0]), Number(message.parameters[1]), Number(message.parameters[2]), Number(message.parameters[3]));
                    }
                    break;
                }
                case "outlineButton":
                    if (message.objName) {
                        h.setLastButtonOutline(message.objName);
                        h.setSelectedFilter(message.objName);
                    }
                    break;
                case "selectFilter":
                    if (message.objName)
                        h.setSelectedFilter(message.objName);
                    break;
            }
        }
        catch (err) {
            console.error("Erreur de traitement message Unity:", err, "raw=", message);
        }
    }, [message]);
}
